<template>
  <el-radio-group class="model-radio" v-model="checkedId" :min="1" @change='handleChange'>
    <el-radio v-for="role in roleTypes" :label="role.id" :key="role.id">{{role.name}}</el-radio>
  </el-radio-group>
</template>

<script>
import app from '../js/app'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ['checked', 'roleTypeChecked'],
  data() {
    return {
      obj: {}, //登录信息
      checkedId: '',
      roleTypes: []
    }
  },
  beforeMount() {
    //挂载前取出登陆用户id查询角色
    this.obj = JSON.parse(sessionStorage.loginInfo)
  },
  mounted() {
    this.checkedId = this.roleTypeChecked
    this.selectModels()
  },
  methods: {
    handleChange() {
      this.$emit('change', Number(this.checkedId))
      // this.checkedId = ''
    },
    //查询所有常用语
    selectModels() {
      app.post('getRoleType', { userId: this.obj.id }, 'main').then(d => {
        if (this.handleTableData) d.data = this.handleTableData(d.data)
        this.roleTypes = d.data
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/radio-input.vue